export default "__VITE_ASSET__BOzI$Psa__"